import { render, staticRenderFns } from "./GeradoraList.vue?vue&type=template&id=0b088d50&scoped=true"
import script from "./GeradoraList.vue?vue&type=script&lang=js"
export * from "./GeradoraList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b088d50",
  null
  
)

export default component.exports